import React, { useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import "./index.css";
import "./Component/Common_Component/Common_Modal/Common_Modal.css";
import "./Component/Common_Component/Common_Css/Table/Table.css";
import Login from "./Component/Login/Login";
import Dashboard from "./Component/Dashboard/Dashboard";
import Header from "./Component/Header/Header";
import Sidebar from "./Component/Sidebar/Sidebar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import Country from "./Component/Master/Country/Table";
import State from "./Component/Master/State/Table";
import City from "./Component/Master/City/Table";
import Pincode from "./Component/Master/Pincode/Table";
import CouponCodes from "./Component/CupponsManagement/cuppons/Table";
import BusBooking from "./Component/Booking/BusBooking/Table";
import CabBooking from "./Component/Booking/CabBooking/Table";
import FlightBooking from "./Component/Booking/FlightBooking/Table";
import Customer from "./Component/Customer/Customer/Table";
import ExploreType from "./Component/Master/ExploreType/Table";
import Modules from "./Component/Master/Modules/Table";
import ThingToDo from "./Component/Master/ThingToDo/Table";
import ExplorePlaces from "./Component/Master/ExplorePlaces/Table";
import AppSetup from "./Component/Master/AppSetup/Table";
import Banners from "./Component/Master/Banners/Table";
import Avatars from "./Component/Master/Avatars/Table";
import Vendor from "./Component/Vendor/Vendor/Table";
import AgentAccepted from "./Component/Vendor/AgentAccepted/Table";
import AgentRejected from "./Component/Vendor/AgentRejected/Table";

import UserDeleteReason from "./Component/Master/UserDeleteReason/Table";
import PaymentRefundQuestions from "./Component/Master/PaymentRefundQuestions/Table";
import TechnicalSupportQuestions from "./Component/Master/TechnicalSupportQuestions/Table";
import TravelNews from "./Component/Master/TravelNews/Table";
import FeaturePartner from "./Component/Master/FeaturePartner/Table";
import PopularSearch from "./Component/Master/PopularSearch/Table";
import Policy from "./Component/Master/Policy/Table";
// import WalletHistory from "./Component/wallet_management/walletRequest/Table";
import Notifications from "./Component/Notifications/Notifications/Table";
import FlightAccountSetting from "./Component/Master/FlightAccountSetting/Table";
import FlightPrebookingQuery from "./Component/Master/FlightPrebookingQuery/Table";
import WalletRequest from "./Component/wallet_management/walletRequest/Table";
import WalletAccept from "./Component/wallet_management/walletAccept/Table";
import WalletReject from "./Component/wallet_management/walletReject/Table";
import WalletHistory from "./Component/wallet_management/walletHistory/Table";
import TitliHistory from "./Component/Titli_Soorat/titli_history/Table";
// import TeenPatti from "./Component/TeenPatti";

import Inquiry from "./Component/Inquiry/Inquiry/Table";

import MiddelWare from "./Middleware";
import { IDS } from "./utils/common";
import { useContext } from "react";
import { Context } from "./utils/context";
import { useEffect } from "react";

import RouletteHistory from "./Component/Roulette/history/Table";
import RoulettePayout from "./Component/Master/RoulettePayout/Table";

function App() {
  const location = useLocation();
  const { isSidebarOpen, isAllow, toggleSidebar, signin } = useContext(Context);
  const [headerText, setHeaderText] = useState(location.pathname);

  const isLoginPage = location.pathname === "/";

  useEffect(() => {
    setHeaderText(location.pathname);
  });

  const [urls, setUrls] = useState([]);
  useEffect(() => {
    setUrls([
      {
        path: "/",
        element: <Login />,
        status: true,
      },
      {
        path: "/dashboard",
        element: <Dashboard />,
        status: true,
      },
      {
        path: "/banners",
        element: <Banners />,
        status: true,
        // status: isAllow?.includes(IDS.Role.List),
      },
      {
        path: "/roulette-payout",
        element: <RoulettePayout />,
        status: true,
        // status: isAllow?.includes(IDS.Role.List),
      },
      {
        path: "/avatars",
        element: <Avatars />,
        status: true,
        // status: isAllow?.includes(IDS.Role.List),
      },
      {
        path: "/app-setup",
        element: <AppSetup />,
        status: true,
        // status: isAllow?.includes(IDS.Role.List),
      },

      {
        path: "/country",
        element: <Country />,
        status: true,
        // status: isAllow?.includes(IDS.Role.List),
      },

      {
        path: "/state",
        element: <State />,
        status: true,
        // status: isAllow?.includes(IDS.Role.List),
      },
      {
        path: "/city",
        element: <City />,
        status: true,
        // status: isAllow?.includes(IDS.Role.List),
      },
      {
        path: "/pincode",
        element: <Pincode />,
        status: true,
        // status: isAllow?.includes(IDS.Role.List),
      },
      // {
      //   path: "/coupon-node",
      //   element: <CouponCodes />,
      //   status: true,
      //   // status: isAllow?.includes(IDS.Role.List),
      // },
      // {
      //   path: "/booking/bus-booking",
      //   element: <BusBooking />,
      //   status: true,
      //   // status: isAllow?.includes(IDS.Role.List),
      // },
      // {
      //   path: "/booking/bus-booking/:id",
      //   element: <BusBooking />,
      //   status: true,
      //   // status: isAllow?.includes(IDS.Role.List),
      // },
      // {
      //   path: "/booking/bus-booking/:agentId",
      //   element: <BusBooking />,
      //   status: true,
      //   // status: isAllow?.includes(IDS.Role.List),
      // },
      // {
      //   path: "/booking/flight-booking",
      //   element: <FlightBooking />,
      //   status: true,
      //   // status: isAllow?.includes(IDS.Role.List),
      // },
      // {
      //   path: "/booking/flight-booking/:id",
      //   element: <FlightBooking />,
      //   status: true,
      //   // status: isAllow?.includes(IDS.Role.List),
      // },
      // {
      //   path: "/booking/flight-booking/:agentId",
      //   element: <FlightBooking />,
      //   status: true,
      //   // status: isAllow?.includes(IDS.Role.List),
      // },
      // {
      //   path: "/booking/cab-booking",
      //   element: <CabBooking />,
      //   status: true,
      //   // status: isAllow?.includes(IDS.Role.List),
      // },
      // {
      //   path: "/booking/cab-booking/:id",
      //   element: <CabBooking />,
      //   status: true,
      //   // status: isAllow?.includes(IDS.Role.List),
      // },
      // {
      //   path: "/booking/cab-booking/:agentId",
      //   element: <CabBooking />,
      //   status: true,
      //   // status: isAllow?.includes(IDS.Role.List),
      // },
      {
        path: "/customer/customer",
        element: <Customer />,
        status: true,
        // status: isAllow?.includes(IDS.Role.List),
      },
      // {
      //   path: "/inquiry/inquiry",
      //   element: <Inquiry />,
      //   status: true,
      //   // status: isAllow?.includes(IDS.Role.List),
      // },
      // {
      //   path: "/agent-management/agents-requested",
      //   element: <Vendor />,
      //   status: true,
      //   // status: isAllow?.includes(IDS.Role.List),
      // },
      // {
      //   path: "/agent-management/agents-accepted",
      //   element: <AgentAccepted />,
      //   status: true,
      //   // status: isAllow?.includes(IDS.Role.List),
      // },
      // {
      //   path: "/agent-management/agents-rejected",
      //   element: <AgentRejected />,
      //   status: true,
      //   // status: isAllow?.includes(IDS.Role.List),
      // },
      // {
      //   path: "/explore-type",
      //   element: <ExploreType />,
      //   status: true,
      //   // status: isAllow?.includes(IDS.Role.List),
      // },
      // {
      //   path: "/thing-to-do",
      //   element: <ThingToDo />,
      //   status: true,
      //   // status: isAllow?.includes(IDS.Role.List),
      // },
      // {
      //   path: "/explore-places",
      //   element: <ExplorePlaces />,
      //   status: true,
      //   // status: isAllow?.includes(IDS.Role.List),
      // },

      // {
      //   path: "/user-delete-reason",
      //   element: <UserDeleteReason />,
      //   status: true,
      //   // status: isAllow?.includes(IDS.Role.List),
      // },
      // {
      //   path: "/support/payment-refund-questions",
      //   element: <PaymentRefundQuestions />,
      //   status: true,
      //   // status: isAllow?.includes(IDS.Role.List),
      // },
      // {
      //   path: "/support/technical-support-questions",
      //   element: <TechnicalSupportQuestions />,
      //   status: true,
      //   // status: isAllow?.includes(IDS.Role.List),
      // },
      // {
      //   path: "/travel-news",
      //   element: <TravelNews />,
      //   status: true,
      //   // status: isAllow?.includes(IDS.Role.List),
      // },
      // {
      //   path: "/feature-partners",
      //   element: <FeaturePartner />,
      //   status: true,
      //   // status: isAllow?.includes(IDS.Role.List),
      // },
      // {
      //   path: "/popular-search",
      //   element: <PopularSearch />,
      //   status: true,
      //   // status: isAllow?.includes(IDS.Role.List),
      // },
      {
        path: "/policy",
        element: <Policy />,
        status: true,
        // status: isAllow?.includes(IDS.Role.List),
      },

      {
        path: "/notifications",
        element: <Notifications />,
        status: true,
        // status: isAllow?.includes(IDS.Role.List),
      },
      // {
      //   path: "/flight-account-setting",
      //   element: <FlightAccountSetting />,
      //   status: true,
      //   // status: isAllow?.includes(IDS.Role.List),
      // },
      // {
      //   path: "/flight-prebooking-query",
      //   element: <FlightPrebookingQuery />,
      //   status: true,
      //   // status: isAllow?.includes(IDS.Role.List),
      // },
      {
        path: "/wallet/request",
        element: <WalletRequest />,
        status: true,
        // status: isAllow?.includes(IDS.Role.List),
      },
      {
        path: "/wallet/accept",
        element: <WalletAccept />,
        status: true,
        // status: isAllow?.includes(IDS.Role.List),
      },
      {
        path: "/wallet/rejected",
        element: <WalletReject />,
        status: true,
        // status: isAllow?.includes(IDS.Role.List),
      },
      {
        path: "/wallet/history",
        element: <WalletHistory />,
        status: true,
        // status: isAllow?.includes(IDS.Role.List),
      },

      {
        path: "/titli-history",
        element: <TitliHistory />,
        status: true,
        // status: isAllow?.includes(IDS.Role.List),
      },
      {
        path: "/roulette-history",
        element: <RouletteHistory />,
        status: true,
        // status: isAllow?.includes(IDS.Role.List),
      },
    ]);
  }, [isAllow]);

  return (
    <>
      {isLoginPage && !signin ? (
        <Login />
      ) : (
        <>
          <Header />
          <section className="Dashboard">
            <div className="row me-0 ms-0">
              <div>
                <button
                  className="btn sidebar-toggle d-lg-none"
                  onClick={toggleSidebar}
                >
                  <FontAwesomeIcon
                    icon={faArrowRight}
                    className={isSidebarOpen ? "icon-rotate" : ""}
                  />
                </button>
              </div>

              <div
                className={`offcanvas-sidebar ${isSidebarOpen ? "open" : ""
                  } col-xxl-2 col-xl-3 col-lg-3 col-md-3 col-sm-4 col-8 p-0`}
              >
                <div className="sidebar_holder">
                  <Sidebar />
                </div>
              </div>

              <div className="col-xxl-10 col-xl-9 col-lg-9 col-md-12 col-sm-12 col-12">
                <div className="main-content-holder">
                  <Routes>
                    {/* <Route
                    path="/dashboard"
                    element={<MiddelWare component={Dashboard} />}
                  /> */}

                    {urls?.map(
                      (url, index) =>
                        url.status && (
                          <Route
                            key={index}
                            path={url.path}
                            element={<MiddelWare component={url.element} />}
                          // element={url.element}
                          />
                        )
                    )}

                    {/* <Route path="/dashboard" element={<Dashboard />} />
                    <Route
                      path="/customer-management"
                      element={<Customer_Management />}
                    />
                    <Route
                      path="/view-played-game"
                      element={<View_Played_Game />}
                    />
                    <Route path="/view-list" element={<View_List />} />
                    <Route path="/banner" element={<Banner_View_List />} />
                    <Route path="/profile" element={<Profile />} />
                    <Route path="/total-amount" element={<Total_Amount />} />
                    */}
                  </Routes>
                </div>
              </div>
            </div>
          </section>
        </>
      )}
      {/* {!isLoginPage && <Header />}
      <Routes>
        <Route path="/" element={<Login />} />
      </Routes> */}

      {/* Render Dashboard section only if not on the login page */}
      {/* {!isLoginPage && (
        <section className="Dashboard">
          <div className="row me-0 ms-0">
            <div>
              <button
                className="btn sidebar-toggle d-lg-none"
                onClick={toggleSidebar}
              >
                <FontAwesomeIcon
                  icon={faArrowRight}
                  className={isSidebarOpen ? "icon-rotate" : ""}
                />
              </button>
            </div>

            <div
              className={`offcanvas-sidebar ${
                isSidebarOpen ? "open" : ""
              } col-xxl-2 col-xl-3 col-lg-3 col-md-3 col-sm-4 col-8 ps-0`}
            >
              <div className="sidebar_holder">
                <Sidebar />
              </div>
            </div>

            <div className="col-xxl-10 col-xl-9 col-lg-9 col-md-12 col-sm-12 col-12">
              <div className="main-content-holder">
                <Routes>
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route
                    path="/customer-management"
                    element={<Customer_Management />}
                  />
                  <Route
                    path="/view-played-game"
                    element={<View_Played_Game />}
                  />
                  <Route path="/view-list" element={<View_List />} />
                  <Route path="/banner" element={<Banner_View_List />} />
                  <Route path="/profile" element={<Profile />} />
                  <Route path="/total-amount" element={<Total_Amount />} />
                  <Route path="/profile-data" element={<Profile_data_List />} />
                </Routes>
              </div>
            </div>
          </div>
        </section>
      )} */}
    </>
  );
}

export default App;
